// Coordenadas da localização especificada
var latitude = document.querySelector("#lat").value;
var longitude = document.querySelector("#lng").value;

let iconWidthAndHeight = [
    screen.width > 992 ? 64 : 64,
    screen.width > 992 ? 88 : 88,
]

// Criando o mapa com base nas coordenadas especificadas
var map = L.map('mapa', {
    closePopupOnClick: false
}).setView([latitude, longitude], 14);

// Desabilitar o scroll do mouse
map.scrollWheelZoom.disable();

// Criando uma camada de mapa
var layer = new L.TileLayer(
   "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        maxZoom: 16
   }
);
// Adicionando a camada ao mapa
map.addLayer(layer);

let customIcon = {
   iconUrl: document.querySelector("#map-icon").value,
   iconSize: [iconWidthAndHeight[0], iconWidthAndHeight[1]],
   popupAnchor: [0, -40],
   setZIndex: 10,
}
let myIcon = L.icon(customIcon);

let iconOptions = {
   title: 'Zanette Frutas',
   draggable: false,
   icon: myIcon,
}

// Criando o marcador
let marker = new L.Marker([latitude, longitude], iconOptions);
let address = document.querySelector("#address").value;
let addressLink = document.querySelector("#address_link").value;
let cardTitle = document.querySelector("#card_title").value;
let mapSvg = document.querySelector("#map-svg").value;
marker.addTo(map);

// Bind do popup com opções
marker.bindPopup(
    `
    <div class="title">
        <h4>${cardTitle}</h4>
        <div class="arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19" fill="none">
                <path d="M23.776 9.84166L14.5842 18.4736C14.439 18.6007 14.247 18.6698 14.0485 18.6666C13.8501 18.6633 13.6608 18.5878 13.5204 18.456C13.3801 18.3242 13.2997 18.1464 13.2962 17.96C13.2927 17.7737 13.3664 17.5933 13.5017 17.457L21.3849 10.0527H0.765979C0.562829 10.0527 0.367999 9.97688 0.22435 9.84198C0.080701 9.70708 0 9.52411 0 9.33333C0 9.14256 0.080701 8.95959 0.22435 8.82469C0.367999 8.68979 0.562829 8.614 0.765979 8.614H21.3849L13.5017 1.20971C13.3664 1.07335 13.2927 0.892994 13.2962 0.706639C13.2997 0.520284 13.3801 0.34248 13.5204 0.210686C13.6608 0.078893 13.8501 0.00340009 14.0485 0.000112069C14.247 -0.00317595 14.439 0.0659975 14.5842 0.19306L23.776 8.82501C23.9194 8.95988 24 9.14271 24 9.33333C24 9.52396 23.9194 9.70679 23.776 9.84166Z" fill="#1F2C07"/>
            </svg>
        </div>
    </div>
    <a href="${addressLink}" target="_blank">
        <img src="${mapSvg}" alt="" aria-hidden="true">
        ${address}
    </a>
    `, {
    autoClose: false,
    closeButton: false,
    closeOnClick: false,
    keepInView: true
}).openPopup();

// prevent popup from closing
// marker.on('click', function (e) {
//     marker.openPopup();
// });

const mapa = document.querySelector('#mapa');